<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-商城设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加提货站点-->
      <div class="common-form">商城设置</div>
      <el-form-item label="商城名称" :rules="[{required: true,message: ' '}]" prop="name">
        <el-input v-model="form.name" placeholder="商城名称" class="max-w460"></el-input>
      </el-form-item>
      <!--      <el-form-item label="配送方式">-->
      <!--        <el-checkbox-group v-model="form.deliveryType">-->
      <!--          <el-checkbox v-for="(item,index) in all_type" :label="item.value" :key="index">{{ item.name }}</el-checkbox>-->
      <!--        </el-checkbox-group>-->
      <!--        <div class="tips">注：配送方式至少选择一个</div>-->
      <!--      </el-form-item>-->
<!--      <el-form-item label="是否显示店铺信息">-->
<!--        <div>-->
<!--          <el-radio v-model="form.storeOpen" label="1">显示</el-radio>-->
<!--          <el-radio v-model="form.storeOpen" label="0">关闭</el-radio>-->
<!--        </div>-->
<!--        <div class="tips">主要用于微信小程序过审隐藏</div>-->
<!--      </el-form-item>-->
      <div class="common-form">日志记录</div>
      <el-form-item label="是否记录查询日志" prop="customer">
        <el-checkbox v-model="form.isGetLog">是否记录查询日志</el-checkbox>
        <div class="tips">如果记录，日志量会有点大</div>
      </el-form-item>
      <div class="common-form">物流查询api</div>
      <el-form-item label="快递100 Customer" :rules="[{required: true,message: ' '}]" prop="kuaiDi100.customer">
        <el-input v-model="form.kuaiDi100.customer" placeholder="" class="max-w460"></el-input>
        <div class="tips">用于查询物流信息,
          <el-link :underline="false" href="https://www.kuaidi100.com/openapi/" target="_blank"
                   type="primary">快递100申请
          </el-link>
        </div>
      </el-form-item>
      <el-form-item label="快递100 Key" :rules="[{required: true,message: ' '}]" prop="kuaiDi100.key">
        <el-input v-model="form.kuaiDi100.key" placeholder="" class="max-w460"></el-input>
      </el-form-item>
<!--      <div class="common-form">商户入驻设置</div>-->
<!--      <el-form-item label="是否开启短信验证">-->
<!--        <div>-->
<!--          <el-radio v-model="form.smsOpen" label="1">开启</el-radio>-->
<!--          <el-radio v-model="form.smsOpen" label="0">关闭</el-radio>-->
<!--        </div>-->
<!--      </el-form-item>-->
      <div class="common-form">平台运营设置</div>
      <el-form-item label="抽成百分比(%)" :rules="[{required: true,message: ' '}]" prop="commissionRate">
        <el-input v-model="form.commissionRate" placeholder="抽查比例" class="max-w460" type="number"></el-input>
      </el-form-item>
      <el-form-item label="商品新增是否审核">
        <div>
          <el-radio v-model="form.addAudit" :label="1">是</el-radio>
          <el-radio v-model="form.addAudit" :label="0">否</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="商品修改是否审核">
        <div>
          <el-radio v-model="form.editAudit" :label="1">是</el-radio>
          <el-radio v-model="form.editAudit" :label="0">否</el-radio>
        </div>
      </el-form-item>
      <div class="common-form">商户图片背景</div>
      <el-form-item label="商户入驻背景" :rules="[{required: true,message: '请输入商户入驻图片'}]">
        <!--        <el-button @click="chooseImg('image')">选择图片</el-button>-->
        <!--        <img class="mt10" v-img-url="form.supplierImage" width="200">-->
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.supplierImage">
            <transition-group>
              <div class="item" v-for="(item, index) in form.supplierImage" :key="item">
                <img v-img-url="item"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                  class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="chooseImg('image')"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>


<!--      <div class="common-form">政策协议</div>-->
<!--      <el-form-item label="服务协议" :rules="[{required: true,message: ' '}]" prop="policy.service">-->
<!--        <el-input v-model="form.policy.service" placeholder="" class="max-w460"></el-input>-->
<!--        <div class="tips">进入app和登录、注册页面显示</div>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="隐私政策" :rules="[{required: true,message: ' '}]" prop="policy.privacy">-->
<!--        <el-input v-model="form.policy.privacy" placeholder="" class="max-w460"></el-input>-->
<!--      </el-form-item>-->
<!--      <div class="common-form">店铺分享设置</div>-->
<!--      <el-form-item label="分享标题" :rules="[{required: true,message: ' '}]" prop="shareSetting.shopShareTitle">-->
<!--        <el-input v-model="form.shareSetting.shopShareTitle" placeholder="" class="max-w460"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="分享背景" :rules="[{required: true,message: '请输入店铺分享背景图片'}]">-->
<!--        <el-button @click="chooseImg('shareBg')">选择图片</el-button>-->
<!--        <img class="mt10" v-img-url="form.shareSetting.shopShareImage" width="200">-->
<!--      </el-form-item>-->
      <div class="common-form">开店保证金设置</div>
      <el-form-item label="开店支付资金" :rules="[{required: true,message: ' '}]" prop="depositMoney">
        <el-input v-model="form.depositMoney" type="number" style="width: 200px;"></el-input>
        元
      </el-form-item>
      <div class="common-form">店铺二维码背景设置</div>
      <el-form-item label="店铺二维码背景" :rules="[{required: true,message: '请选择店铺二维码背景图片'}]">
        <el-button @click="chooseImg('shopBg')">选择图片</el-button>
        <span class="tips m-l-20">图片尺寸：800 * 1200</span>
        <img class="mt10" v-img-url="form.shopBg" width="200">
      </el-form-item>
      <div class="common-form">政策协议</div>
      <el-form-item label="服务协议" :rules="[{required: true,message: ' '}]" prop="policy.service">
        <el-input v-model="form.policy.service" placeholder="" class="max-w460"></el-input>
        <div class="tips">进入申请店铺页面显示</div>
      </el-form-item>
      <el-form-item label="协议内容" :rules="[{required: true,message: ' '}]" prop="policy.serviceContent">
        <Uediter :text="content" :config="ueditor.config" @contentChange="contentChangeFunc" ref="ue"></Uediter>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload>

  </div>

</template>

<script>
import SettingApi from '@/api/setting.js'
import Upload from '@/components/file/Upload'
import {formatModel} from '@/utils/base.js'
import draggable from 'vuedraggable'
import Uediter from '@/components/UE.vue'

export default {
  components: {
    Upload,
    draggable,
    Uediter
  },
  data () {
    return {
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        name: '',
        kuaiDi100: {
          customer: '',
          key: ''
        },
        supplierCash: '',
        operateType: '',
        commissionRate: '',
        supplierImage: [],
        smsOpen: '',
        storeOpen: '',
        supplierLogo: '',
        checkedCities: [],
        editAudit: 1,
        addAudit: 1,
        service: '',
        privacy: '',
        deliveryType: [],
        isGetLog: 0,
        policy: {
          service: '',
          serviceContent: '',
          privacy: ''
        },
        shareSetting: {
          shopShareImage: '',
          shopShareTitle: ''
        },
        depositMoney: '',
        shopBg: ''
      },
      all_type: [],
      delivery_type: [],
      /*是否打开图片选择*/
      isupload: false,
      content: '',
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 460,
          initialFrameHeight: 500,
        }
      },
    }
  },
  created () {
    this.getParams()
  },

  methods: {
    /*获取配置数据*/
    getParams () {
      let self = this
      SettingApi.storeDetail({}, true).then(res => {
        self.form = formatModel(self.form, res.data)
        self.content = res.data.policy.serviceContent || ''
        self.$nextTick(() => {
          self.$refs.ue.refreshContent()
        })
        self.all_type = res.data.allType
        self.loading = false
      })
        .catch(error => {
          console.log(error)
        })

    },

    /*选择图片*/
    chooseImg (e) {
      this.type = e
      this.isupload = true
    },

    /*关闭选择图片*/
    returnImgsFunc (e) {
      this.isupload = false
      if (e != null && e.length > 0) {
        if (this.type == 'logo') {
          this.form.supplierLogo = e[0].filePath
        } else if (this.type == 'image') {
          let imageList = e.map(res => {
            return res.filePath
          })
          this.form.supplierImage = this.form.supplierImage.concat(imageList)
        } else if (this.type === 'shareBg') {
          this.form.shareSetting.shopShareImage = e[0].filePath
        } else if (this.type === 'shopBg') {
          this.form.shopBg = e[0].filePath
        }
      }
    },

    /*提交*/
    onSubmit () {
      let self = this
      let params = this.form
      if (params.deliveryType.length < 1) {
        self.$message({
          message: '配送方式至少选择一种！',
          type: 'warning'
        })
        return
      }

      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true
          SettingApi.editStore(params, true)
            .then(data => {
              self.loading = false
              self.$message({
                message: '恭喜你，商城设置成功',
                type: 'success'
              })
              self.$router.push('/setting/store/index')
            })
            .catch(error => {
              self.loading = false
            })
        }
      })
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.form.supplierImage.splice(index, 1)
    },
    contentChangeFunc (e) {
      this.content = e
      this.form.policy.serviceContent = e
    }
  }

}
</script>
<style>
.tips {
  color: #ccc;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/store/index.vue